/**
 * Created by Ning Jiang on 3/20/2017.
 */

import {SpinServerDataParser} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinServerDataParser";
import {IWildNudgeGameData, IWildNudgeServerData} from "./data/IWildNudgeServerData";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/core/utils/ArrayHelper";
import {MathHelper} from "@nolimitcity/slot-game/bin/core/utils/MathHelper";

export class WildNudgeServerDataParser extends SpinServerDataParser {

    constructor() {
        super();
    }

    public parseStackedSpinTriggered(rawData:IWildNudgeServerData):boolean {
        return rawData.stackedSpinTriggered;
    }

    public parseActiveStackedSymbol(rawData:IWildNudgeServerData):string {
        return rawData.activeStackedSymbol;
    }

    public parseInitialStackOverlay(rawData:IWildNudgeGameData):boolean[] {
        return rawData.initialStackOverlay;
    }

    public parseStackOverlay(rawData:IWildNudgeGameData):boolean[][] {
        return rawData.stackOverlay;
    }

    public parseDoReelNudge(rawData:IWildNudgeGameData):boolean[] {
        return rawData.doReelNudge.concat();
    }

    public parseDoScatterNudge(rawData:IWildNudgeGameData):boolean[] {
        return rawData.doScatterNudge.concat();
    }

    public parseStackedModeSymbolInWin(rawData:IWildNudgeGameData):boolean[] {
        return rawData.stackedModeSymbolInWin.concat();
    }

    public parseExtraSymbolsOnTop(rawData:IWildNudgeGameData):string[][] {
        if(rawData.stackedSpinTriggered != undefined && rawData.stackedSpinTriggered) {
            const result:string[][] = [];
            rawData.extraSymbolsOnTop.forEach((reelSymbols:string[], reelId:number) => {
                let newReel:string[] = [];
                reelSymbols.forEach((symbol:string, symbolId:number) => {
                    newReel[symbolId] = symbol === "X" ? rawData.activeStackedSymbol : symbol;
                });
                result[reelId] = newReel;
            });
            return WildNudgeServerDataParser.parseStackedSymbolsInReels(result);
        }
        return WildNudgeServerDataParser.parseStackedSymbolsInReels(rawData.extraSymbolsOnTop);
    }

    // override
    public parseReels(rawData:IWildNudgeServerData):string[][] {
        if(rawData.stackedSpinTriggered != undefined && rawData.stackedSpinTriggered) {
            const featureArray:string[] = ArrayHelper.initArrayWithValues<string>(4, (index:number):string => {
                return rawData.activeStackedSymbol;
            });
            const result:string[][] = [];
            rawData.reels.forEach((reelSymbols:string[], reelId:number) => {
                if((<IWildNudgeGameData>rawData).initialStackOverlay != null && (<IWildNudgeGameData>rawData).initialStackOverlay[reelId]) {
                    result[reelId] = [WildNudgeServerDataParser.getRandomLowSymbol()].concat(featureArray).concat([WildNudgeServerDataParser.getRandomLowSymbol()]);
                } else {
                    let newReel:string[] = [];
                    reelSymbols.forEach((symbol:string, symbolId:number) => {
                        newReel[symbolId] = symbol === "X" ? rawData.activeStackedSymbol : symbol;
                    });
                    result[reelId] = newReel;
                }
            });
            return WildNudgeServerDataParser.parseStackedSymbolsInReels(result);
        }
        return WildNudgeServerDataParser.parseStackedSymbolsInReels(rawData.reels);
    }

    private static _LOW_SYMBOLS:string[] = ["L1", "L2", "L3", "L4"];

    private static getRandomLowSymbol():string {
        return WildNudgeServerDataParser._LOW_SYMBOLS[MathHelper.randomNumberInRange(0, 3)];
    }
}
